import type { MetadataRoute } from "next";
import { site } from "@/content/site";

// Official Next.js App Router robots convention (app/robots.ts → /robots.txt).
export default function robots(): MetadataRoute.Robots {
  return {
    rules: [
      {
        userAgent: "*",
        allow: "/",
        disallow: ["/api/"],
      },
    ],
    sitemap: `${site.url}/sitemap.xml`,
    host: site.url,
  };
}
